"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var text_1 = __importDefault(require("@pixum/text"));
require("./style.css");
var BarRating = function BarRating(_a) {
  var className = _a.className,
    description = _a.description,
    _b = _a.maxRatingScale,
    maxRatingScale = _b === void 0 ? 5 : _b,
    totalRatings = _a.totalRatings,
    ratingIndex = _a.ratingIndex,
    ratingCount = _a.ratingCount,
    onSelect = _a.onSelect;
  var ratingPercentage = Math.round(100 / totalRatings * ratingCount);
  var ratingScale = maxRatingScale - ratingIndex;
  var currentRatingIndex = ratingIndex !== 0 ? maxRatingScale - ratingIndex : maxRatingScale;
  var isClickable = ratingPercentage > 0;
  var handleRatingSelect = function handleRatingSelect() {
    isClickable && onSelect ? onSelect(currentRatingIndex) : function () {};
  };
  return react_1.default.createElement("div", {
    className: (0, clsx_1.default)('rating__bar', className, isClickable && 'rating__bar--clickable'),
    key: ratingIndex,
    onClick: handleRatingSelect
  }, react_1.default.createElement(text_1.default, {
    className: "rating__bar__scale",
    tag: "div"
  }, react_1.default.createElement(text_1.default, {
    variant: "caption"
  }, ratingScale, " ", description)), react_1.default.createElement(text_1.default, {
    className: "rating__bar__frequency",
    tag: "div"
  }, react_1.default.createElement("span", {
    style: {
      width: ratingPercentage + "%"
    }
  })), react_1.default.createElement(text_1.default, {
    className: "rating__bar__percentage"
  }, react_1.default.createElement(text_1.default, {
    variant: "caption"
  }, ratingPercentage + " %")));
};
exports.default = BarRating;